

import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useMediaQuery } from "@mui/material";
import { tabsClasses } from "@mui/material/Tabs";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import HDFC from "./HDFC";
import Razorpay from "./RazorPay";

const StudentReport = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [value, setValue] = React.useState("razorpay");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>

      <TabContext value={value}>
        <TabsWrapper sx={{ width: isMobile ? "100%" : "auto" }}>
          <TabList
            variant="scrollable"
            scrollButtons={isMobile}
            allowScrollButtonsMobile
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
              width: isMobile ? "85vw" : "auto",
            }}
            aria-label="basic tabs example"
            onChange={handleChange}
          >
            <Tab wrapped label="RazorPay" value="razorpay" />
            <Tab wrapped label="HDFC" value="hdfc" />
          </TabList>
        </TabsWrapper>
        <TabPanel value="razorpay" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 1 }}>
            <Razorpay />
          </Box>
        </TabPanel>
        <TabPanel value="hdfc" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 1 }}>
            <HDFC />
          </Box>
        </TabPanel>
      </TabContext>

    </>
  );
};

export default StudentReport;